import { toLowerSafe, toTitleCase, toUpperSafe } from "../textFormatter";
import { formatDateTime } from "../dateFormatter";

const buildCliente = (data) => ({
  id_cliente: data.id_cliente || null,
  rut: data.clienteRut || null,
  nombre: toTitleCase(data.clienteNombre) || null,
  celular: data.clienteCelular || null,
  correo: toLowerSafe(data.clienteCorreo) || null
});

const buildVehiculo = (data) => ({
  id_vehiculo: data.id_vehiculo || null,
  patente: toUpperSafe(data.patente) || '',
  marca: toTitleCase(data.marca) || '',
  modelo: toTitleCase(data.modelo) || '',
  anio: data.anio || null,
  nmotor: toUpperSafe(data.nmotor) || null,
  nserie: toUpperSafe(data.nserie) || null,
  kilometrajeAct: data.km_ingreso || 0, //20.000km
  kilometrajeProx:
    Number(data.km_ingreso) +
    Number(data.km_prox_mantencion), // 30.000km
  tipoCombustible: data.tipo_combustible || null,
});

const buildServicios = (data, serviciosExistentes = []) =>
  (data.id_servicios || [])
    .map(idServicio => ({ 
      id_servicio: idServicio,
      id_relacion: serviciosExistentes
        .find(s => s.id_servicio === idServicio)?.id_relacion ?? null,
    }));

const buildTrabajadores = (data, trabajadoresExistentes = []) => {
  const buscarRelacion = (idTrabajador, tipo) =>
    trabajadoresExistentes
      .find(t => t.id_trabajador === idTrabajador && t.tipo_trabajador === tipo)
      ?.id_relacion ?? null;

  return [
    ...(data.id_tecnico 
    ? [{ 
        id_trabajador: data.id_tecnico,
        tipo_trabajador: 'tecnico',
        id_relacion: buscarRelacion(data.id_tecnico, 'tecnico'),
      }]
    : [] ),
    ...(data.id_mecanicos || []).map(idMecanico => ({ 
      id_trabajador: idMecanico,
      tipo_trabajador: 'mecanico',
      id_relacion: buscarRelacion(idMecanico, 'mecanico'),
    })),
  ];
};

const buildRecepcion = (data) => ({
  id_centrocosto: data.id_centrocosto,
  fecha_ingreso: formatDateTime(data.fechaIngreso),
  fecha_salida: formatDateTime(data.fechaSalida),
  motivo_ingreso: data.sintomas, 
  km_ingreso: data.km_ingreso, //20.000km
  km_prox_mantencion: data.km_prox_mantencion, //10.000km
  nivelCombustible: data.nivel_combustible
});

const buildEvaluaciones = (data) =>
Object.entries(data.evaluacionDanos || {})
.filter(([, estado]) => 
  estado !== null 
  && estado !== undefined 
  && estado !== '')
.map(
  ([idParte, estado]) => ({ 
    id_parte: Number(idParte), 
    estado 
  })
);

const buildDiagrama = (data, trazosDanos, imagenFinal) => ({
  tipo_silueta: data.imagenVehiculoTipo,
  trazos: trazosDanos,
  imagenFinal: imagenFinal ?? null,
});

export const buildPayloadPaso1 = (data, trazosDanos, imagenFinal, valoresIniciales) => ({
  cliente: buildCliente(data),
  vehiculo: buildVehiculo(data),
  servicios: buildServicios(data, valoresIniciales?.servicios),
  trabajadores: buildTrabajadores(data, valoresIniciales?.trabajadores),
  recepcion: buildRecepcion(data),
  evaluacion: buildEvaluaciones(data),
  diagrama: buildDiagrama(data, trazosDanos, imagenFinal),
  entregarVehiculo: false
});